// window is undefined when this module is imported on the server
const appConfig = typeof window === 'undefined' ? undefined : window.appConfig;

export const DEPLOYMENT = appConfig?.DEPLOYMENT || import.meta.env.VITE_DEPLOYMENT;

export const DOCKER_IMAGE = appConfig?.DOCKER_IMAGE || import.meta.env.VITE_DOCKER_IMAGE;

export const AUTH0_AUDIENCE = appConfig?.AUTH0_AUDIENCE || import.meta.env.VITE_AUTH0_AUDIENCE;

export const AUTH0_CLIENT_ID = appConfig?.AUTH0_CLIENT_ID || import.meta.env.VITE_AUTH0_CLIENT_ID;

export const AUTH0_DOMAIN = appConfig?.AUTH0_DOMAIN || import.meta.env.VITE_AUTH0_DOMAIN;

export const AUTH0_RESPONSE_TYPE = appConfig?.AUTH0_RESPONSE_TYPE || import.meta.env.VITE_AUTH0_RESPONSE_TYPE;

export const AUTH0_SCOPE = appConfig?.AUTH0_SCOPE || import.meta.env.VITE_AUTH0_SCOPE;

export const AUTH0_REDIRECT_URL = appConfig?.AUTH0_REDIRECT_URL || import.meta.env.VITE_AUTH0_REDIRECT_URL;

export const CLEOS_API_BASE = appConfig?.CLEOS_API_BASE || import.meta.env.VITE_CLEOS_API_BASE;

export const CLEOS_API_VERSION = appConfig?.CLEOS_API_VERSION || import.meta.env.VITE_CLEOS_API_VERSION;

export const CLEOS_REPORTS_API_BASE = appConfig?.CLEOS_REPORTS_API_BASE || import.meta.env.VITE_CLEOS_REPORTS_API_BASE;

export const CLEOS_REPORTS_API_VERSION =
  appConfig?.CLEOS_REPORTS_API_VERSION || import.meta.env.VITE_CLEOS_REPORTS_API_VERSION;

export const ESS_API_BASE = appConfig?.ESS_API_BASE || import.meta.env.VITE_ESS_API_BASE;

export const ESS_API_VERSION = appConfig?.ESS_API_VERSION || import.meta.env.VITE_ESS_API_VERSION;

export const CLEOS_XLEDGER_API_BASE = appConfig?.CLEOS_XLEDGER_API_BASE || import.meta.env.VITE_CLEOS_XLEDGER_API_BASE;

export const CLEOS_XLEDGER_API_VERSION =
  appConfig?.CLEOS_XLEDGER_API_VERSION || import.meta.env.VITE_CLEOS_XLEDGER_API_VERSION;

export const INSPECTION_API_BASE = appConfig?.INSPECTION_API_BASE || import.meta.env.VITE_INSPECTION_API_BASE;

export const INSPECTION_API_VERSION = appConfig?.INSPECTION_API_VERSION || import.meta.env.VITE_INSPECTION_API_VERSION;
